import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  const minutes = index % 9 + 1;
  return <AnimatePresence data-id="element-20" data-mp="1gx2v0aof5zx3">
      {open && !dismissed && <motion.div role="status" initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed left-3 right-3 bottom-[92px] z-50 sm:right-auto sm:left-5 sm:bottom-24 sm:w-[340px]" data-id="element-21" data-mp="1657lb504nvzr">
          <div className="relative flex items-center gap-3 rounded-2xl border border-brand-100 bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(38,16,64,0.35)]" data-id="element-22" data-mp="n6bpjp8mf9jt">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-cta-light" data-id="element-23" data-mp="iaekif2t5pmc">
              <CheckCircle2Icon className="h-6 w-6 text-cta" aria-hidden="true" data-id="element-24" data-mp="s67w9w8pdf32" />
            </span>
            <div className="min-w-0 text-sm leading-snug" data-id="element-25" data-mp="28kg6qsg77xyc">
              <p className="text-ink" data-id="element-26" data-mp="28imvezun4pk0">
                <span className="font-bold" data-id="element-27" data-mp="23ln11m75lb8q">{buyer.name}</span> from{' '}
                <span className="font-semibold" data-id="element-28" data-mp="23nhaa392bewz">{buyer.place}</span>
              </p>
              <p className="text-muted" data-id="element-29" data-mp="2aobempxl44xk">
                just purchased the <span className="font-semibold text-brand-700" data-id="element-30" data-mp="2fmv3oz7h5wu5">Ortho Decision System™</span>
              </p>
              <p className="mt-0.5 text-xs text-muted" data-id="element-31" data-mp="2knsir2x6uarf">{minutes} min ago · Verified purchase</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 rounded-full p-1 text-muted hover:text-ink" data-id="element-32" data-mp="2pkj0rvsjzgfh">
              <XIcon className="h-4 w-4" data-id="element-33" data-mp="21wj8usji9jzb" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}